import useGetApi from 'src/api/useGetApi';

export interface DetailedCustomerDTO {
  id: string;
  name: string;
  erpDisplayName?: string | null;
  address?: string | null;
  longitude?: number | null;
  latitude?: number | null;
  aliases?: string[] | null;
  phoneNumber?: string | null;
  emailDomain?: string | null;
  contactPerson?: string | null;
  paymentTerms?: string | null;
  creditLimit?: number | null;
  creditLimitCurrency?: string | null;
  isaId?: string | null;

  products?: Array<{
    id: string;
    productId: string;
    productVariantId: string;
    customerDescription?: string | null;
    customerMainIdentifier?: string | null;
    customerSku?: string | null;
    customerUpc?: string | null;
    customerPlu?: string | null;
    customerEan?: string | null;
    customerGtin?: string | null;
    customerAsin?: string | null;
    customerMpn?: string | null;
    customerIsbn?: string | null;
    customerNsn?: string | null;
    createdByUserId?: string | null;
    originId?: string | null;
    originSystem?: string | null;
    originEntity?: string | null;
    originMetadata?: Record<string, unknown> | null;
    matchSequence: number;
    productVariant: {
      productId: string;
      attributes: Record<string, unknown>;
      variantSignature?: string;
      upc?: string | null;
      sku?: string | null;
      active?: boolean;
      originId?: string | null;
      originSystem?: string | null;
      originEntity?: string | null;
      originMetadata?: Record<string, unknown> | null;
      originAttributes?: Record<string, unknown> | null;
    };
  }>;
  purchaseOrders?: Array<{
    id: string;
    purchaseOrderNumber: string;
    stagedCustomerPurchaseOrderId?: string | null;
    totalAmount?: number | null;
    deliveryDate?: Date | null;
    salesOrder?: {
      id: string;
      internalId: number;
    } | null;
    createdAt: Date;
  }>;
  aiGeneratedEmails?: Array<{
    id: string;
    to: string;
    subject: string;
    body: string;
    sender: {
      id: string;
      name: string;
    };
    usedWithoutEdits?: boolean | null;
    sentAt?: Date | null;
    createdAt: Date;
  }>;
  contacts?: Array<{
    id: string;
    name: string;
    title?: string | null;
    email?: string | null;
    phone?: string | null;
    isPrimary: boolean;
  }>;
  locations?: Array<{
    id: string;
    name: string | null;
    dunsNumber?: string | null;
    address: string | null;
    longitude: number | null;
    latitude: number | null;
  }>;
}

interface GetCustomerResponse {
  customer: DetailedCustomerDTO;
}

export interface QueryParams {
  include?: Array<
    | 'products'
    | 'purchaseOrders'
    | 'aiGeneratedEmails'
    | 'contacts'
    | 'isaId'
    | 'locations'
  >;
}

const useCustomer = (
  customerId: string | undefined,
  queryParams?: QueryParams,
) => {
  return useGetApi<GetCustomerResponse>({
    endpoint: `accounts-receivable/customers/${customerId}`,
    queryParameters: queryParams,
    options: {
      enabled: !!customerId,
    },
  });
};

export default useCustomer;
